import { FC, ReactNode } from "react";
import { Flex } from "@chakra-ui/react";

const CaseDocumentCardActions: FC<{ children: ReactNode }> = ({ children }) => (
  <Flex align="center" wrap="wrap" gap={4} mt="auto" pt={1}>
    {children}
  </Flex>
);

export default CaseDocumentCardActions;
